package com.ilussobsa.views

import com.ilussobsa.*
import com.ilussobsa.Strings
import com.ilussobsa.liveauction.LiveAuctionScreen
import com.ilussobsa.sdk.currentSession
import com.ilussobsa.sdk.currentUser
import com.ilussobsa.sdk.currentUserSession
import com.ilussobsa.sdk.managesAuctions
import com.ilussobsa.utils.edit
import com.ilussobsa.utils.schedule
import com.lightningkite.UUID
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.locale.RenderSize
import com.lightningkite.kiteui.locale.renderDateToString
import com.lightningkite.kiteui.locale.renderTimeToString
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.dialogPageNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.children
import com.lightningkite.kiteui.views.l2.field
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.lightningdb.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import com.lightningkite.serialization.lensPath

@Routable("/auctions")
class AuctionsScreen() : Page {

    override val title: Reactive<String> = remember {
        Strings.liveAuctions
    }
    val query = remember {
        Query(
            condition<AuctionLane> {
                Condition.And(
                    listOfNotNull(
                        condition(true)
                    )
                )
            },
            orderBy = sort { it.scheduledStart.ascending() },
            limit = 500,
        )
    }

    override fun ViewWriter.render() = frame {
        col {
            val toListen = remember {
                currentSession().auctionLane.query(query())
            }
            card - col {
                h1(Strings.liveAuctions)
                important - atTopStart - button {
                    ::shown { managesAuctions() }
                    row {
                        centered - icon(Icon.schedule, "")
                        centered - text(Strings.scheduleNewAuction)
                    }
                    onClick {
                        dialogPageNavigator.navigate(AuctionConfigureDialog(nullUuid))
                    }
                }
                text(Strings.auctionsAreScheduled)
            }
            expanding - recyclerView {
                children(
                    items = remember { toListen()() },
                    id = { it._id }
                ) {
                    val firstTwoVehicles = remember {
                        currentSession().vehicle.query(
                            Query(it().nextVehicle, limit = 2, orderBy = sort { it.orderingValue })
                        )()
                    }
                    row {
                        card - expanding -link {
                            row {
                                centered - col {
                                    text { ::content { it().scheduledStartInstant.renderDateToString(RenderSize.Abbreviation)} }
                                    text { ::content { it().scheduledStartInstant.renderTimeToString(RenderSize.Abbreviation)} }
                                }
                                expanding - compact - col {
                                    h3 { ::content { it().name } }
                                    text {
                                        ::content {
                                            when (firstTwoVehicles().size) {
                                                0 -> "No vehicles added"
                                                1 -> firstTwoVehicles().first().ymmt
                                                else -> "Several vehicles added"
                                            }
                                        }
                                    }
                                }
//                                centered - text { ::content { "${it().vehicles} vehicles" } }
                            }
                            ::to { val id = it()._id; { LiveAuctionScreen(id) } }
                        }
                        CardSemantic.onNext - button {
                            ::shown{ (currentUser()?.role ?: UserRole.Anonymous) >= UserRole.Manager }
                            centered- icon(Icon.edit, "Edit")
                            action = Action(Strings.edit, Icon.edit) {
                                dialogPageNavigator.navigate(AuctionConfigureDialog(it()._id))
                            }
                        }
                        DangerSemantic.plus(CardSemantic).onNext - button {
                            ::shown{ (currentUser()?.role ?: UserRole.Anonymous) >= UserRole.Manager }
                            centered- icon(Icon.delete, "Delete")
                            action = Action(Strings.delete, Icon.delete) {
                                currentUserSession().auctionLane[it()._id].delete()
                            }
                        }
                    }
                }
            }
        }
    }
}

@Routable("/auction-configure/{id}")
class AuctionConfigureDialog(val id: UUID) : Page {
    override fun ViewWriter.render() = dismissBackground {
        val auctionLane = MutableRemember {
            currentSession().auctionLane[id]() ?: AuctionLane(
                name = "",
                description = "",
                condition = condition(true)
            )
        }
        centered - scrolls - card - col {
            spacing = 2.rem
            h1(Strings.configureScheduledAuction)
            field(Strings.auctionName) {
                textInput {
                    content bind auctionLane.lensPath { it.name }
                }
            }
            field(Strings.scheduledDateAndTime) {
                localDateTimeField {
                    content bind auctionLane.lensPath { it.scheduledStart }.nullable()
                }
            }
            row {
                expanding - space()
                important - button {
                    text(Strings.scheduleAuction)
                    action = Action(Strings.submit, Icon.empty) {
                        currentUserSession().auctionLane.upsert(auctionLane())
                        dialogPageNavigator.dismiss()
                    }
                }
            }
        }
    }
}